// Cliente de leitura da Central de Ajuda (um wrapper por recurso, sobre lib/api.ts). A autorização é
// resolvida no backend por ambiente + permissões; o FE só renderiza o que recebe.
import { getApiBaseUrl, requestJson } from "@/lib/api";

export type HelpArticleSummary = {
  id: string;
  slug: string;
  title: string;
  summary: string | null;
  category: "GETTING_STARTED" | "MODULE_MANUAL" | "ROLE_GUIDE";
  moduleKey: string | null;
  screenKey: string | null;
};

export type HelpImageRef = {
  id: string;
  originalFilename: string | null;
  contentType: string;
};

export type HelpArticleDetail = {
  id: string;
  slug: string;
  title: string;
  summary: string | null;
  environment: "STAFF" | "CLIENT" | "DRIVER";
  category: "GETTING_STARTED" | "MODULE_MANUAL" | "ROLE_GUIDE";
  moduleKey: string | null;
  screenKey: string | null;
  contentMarkdown: string;
  lastReviewedAt: string | null;
  lastReviewedBy: string | null;
  images: HelpImageRef[];
};

export type HelpModuleGroup = {
  moduleKey: string;
  articles: HelpArticleSummary[];
};

export type HelpSections = {
  comeceAqui: HelpArticleSummary[];
  minhaFuncao: HelpArticleSummary[];
  manuais: HelpModuleGroup[];
};

export function fetchHelpSections(): Promise<HelpSections> {
  return requestJson<HelpSections>("/api/v1/help/sections", { silentForbidden: true });
}

export function searchHelp(query: string): Promise<HelpArticleSummary[]> {
  return requestJson<HelpArticleSummary[]>(`/api/v1/help/search?query=${encodeURIComponent(query)}`, {
    silentForbidden: true,
  });
}

export function fetchHelpArticle(idOrSlug: string): Promise<HelpArticleDetail> {
  return requestJson<HelpArticleDetail>(`/api/v1/help/articles/${encodeURIComponent(idOrSlug)}`);
}

/** Ajuda contextual da tela. Devolve null quando não há artigo (204). */
export async function fetchHelpForScreen(screenKey: string): Promise<HelpArticleDetail | null> {
  const result = await requestJson<HelpArticleDetail | undefined>(
    `/api/v1/help/screen?screenKey=${encodeURIComponent(screenKey)}`,
    { silentForbidden: true },
  );
  return result ?? null;
}

/** URL (com gate no backend) da imagem de um artigo. As credenciais vão pelo cookie de sessão. */
export function helpImageUrl(articleId: string, imageId: string): string {
  return `${getApiBaseUrl()}/api/v1/help/articles/${articleId}/images/${imageId}`;
}
